import Footer from './footer.vue'
export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/index.js